import { type } from '@mews/framework';
import ApiComponent from '../apiComponent';
import createRequest from './misc/createRequest';

const BASE_URL = '/identityDocuments';

export default function IdentityDocumentsComponent(apiComponent: $TSFixMe) {
    type.check(apiComponent, ApiComponent);
    const request = createRequest(apiComponent.request, BASE_URL);

    return type.create(IdentityDocumentsComponent, {
        analyze(values: $TSFixMe) {
            return request('/analyze', { ...values });
        },
    });
}
